module.exports = __webpack_public_path__ + "img/left.4c5b6644.png";